export default{
    province_list: {
        420000: '湖北省',
    },
    city_list: {
        420100: '武汉市',
        420200: '黄石市',
        420300: '十堰市',
        420500: '宜昌市',
        420600: '襄阳市',
        420700: '鄂州市',
        420800: '荆门市',
        420900: '孝感市',
        421000: '荆州市',
        421100: '黄冈市',
        421200: '咸宁市',
        421300: '随州市',
        422800: '恩施土家族苗族自治州',
        429400: '仙桃市',
        429500: '潜江市',
        429600: '天门市',
        429700: '神农架林区',
    },
    county_list:{
        420102: '江岸区',
        420103: '江汉区',
        420104: '硚口区',
        420105: '汉阳区',
        420106: '武昌区',
        420107: '青山区',
        420111: '洪山区',
        420112: '东西湖区',
        420113: '汉南区',
        420114: '蔡甸区',
        420115: '江夏区',
        420116: '黄陂区',
        420117: '新洲区',
        420202: '黄石港区',
        420203: '西塞山区',
        420204: '下陆区',
        420205: '开发区·铁山区',
        420222: '阳新县',
        420281: '大冶市',
        420302: '茅箭区',
        420303: '张湾区',
        420304: '郧阳区',
        420322: '郧西县',
        420323: '竹山县',
        420324: '竹溪县',
        420325: '房县',
        420381: '丹江口市',
        420502: '西陵区',
        420503: '伍家岗区',
        420504: '点军区',
        420505: '猇亭区',
        420506: '夷陵区',
        420525: '远安县',
        420526: '兴山县',
        420527: '秭归县',
        420528: '长阳土家族自治县',
        420529: '五峰土家族自治县',
        420581: '宜都市',
        420582: '当阳市',
        420583: '枝江市',
        420602: '襄城区',
        420606: '樊城区',
        420607: '襄州区',
        420624: '南漳县',
        420625: '谷城县',
        420626: '保康县',
        420682: '老河口市',
        420699: '高新区',
        420683: '枣阳市',
        420684: '宜城市',
        420702: '梁子湖区',
        420703: '华容区',
        420704: '鄂城区',
        420799: '葛店开发区',
        420802: '东宝区',
        420804: '掇刀区',
        420822: '沙洋县',
        420881: '钟祥市',
        420882: '京山市',
        420898: '屈家岭',
        420896: '漳河新区',
        420902: '孝南区',
        420921: '孝昌县',
        420922: '大悟县',
        420923: '云梦县',
        420981: '应城市',
        420982: '安陆市',
        420984: '汉川市',
        420997: '临空经济区',
        420999: '高新区',
        421002: '沙市区',
        421003: '荆州区',
        421022: '公安县',
        421023: '监利县',
        421024: '江陵县',
        421081: '石首市',
        421083: '洪湖市',
        421087: '松滋市',
        421004: '文旅区',
        421099: '开发区',
        421102: '黄州区',
        421121: '团风县',
        421122: '红安县',
        421123: '罗田县',
        421124: '英山县',
        421125: '浠水县',
        421126: '蕲春县',
        421127: '黄梅县',
        421181: '麻城市',
        421182: '武穴市',
        421202: '咸安区',
        421221: '嘉鱼县',
        421222: '通城县',
        421223: '崇阳县',
        421224: '通山县',
        421281: '赤壁市',
        421302: '曾都区',
        421321: '随县',
        421381: '广水市',
        421303: '开发区',
        422801: '恩施市',
        422802: '利川市',
        422822: '建始县',
        422823: '巴东县',
        422825: '宣恩县',
        422826: '咸丰县',
        422827: '来凤县',
        422828: '鹤峰县',
        429401:	'沙嘴街道',
        429402:	'干河街道',
        429403:	'龙华山办事处',
        429404:	'郑场镇',
        429405:	'毛嘴镇',
        429406:	'豆河镇',
        429407:	'三伏潭镇',
        429408:	'胡场镇',
        429409:	'长倘口镇',
        429410:	'西流河镇',
        429411:	'沙湖镇',
        429412:	'杨林尾镇',
        429413:	'彭场镇',
        429414:	'张沟镇',
        429415:	'郭河镇',
        429416:	'沔城回族镇',
        429417:	'通海口镇',
        429418:	'陈场镇',
        429419: '工业园区',
        429420:	'九合垸原种场',
        429421:	'沙湖原种场',
        429422:	'五湖渔场',
        429423:	'赵西垸林场',
        429424:	'畜禽良种场',
        429425:	'排湖风景区',
        429501:	'园林办事处',
        429502:	'杨市办事处',
        429503:	'周矶办事处',
        429504:	'广华办事处',
        429505:	'泰丰办事处',
        429506:	'高场办事处',
        429507:	'竹根滩镇',
        429508:	'渔洋镇',
        429509:	'王场镇',
        429510:	'高石碑镇',
        429511:	'熊口镇',
        429512:	'老新镇',
        429513:	'浩口镇',
        429514:	'积玉口镇',
        429515:	'张金镇',
        429516:	'龙湾镇',
        429517:	'江汉石油管理局',
        429518:	'潜江经济开发区',
        429519:	'周矶管理区',
        429520:	'后湖管理区',
        429521:	'熊口管理区',
        429522:	'总口管理区',
        429523:	'白鹭湖管理区',
        429524:	'运粮湖管理区',
        429525:	'浩口原种场',
        429601:	'竟陵街道',
        429602:	'侨乡街道开发区',
        429603:	'杨林街道',
        429604:	'多宝镇',
        429605:	'拖市镇',
        429606:	'张港镇',
        429607:	'蒋场镇',
        429608:	'汪场镇',
        429609:	'渔薪镇',
        429610:	'黄潭镇',
        429611:	'岳口镇',
        429612:	'横林镇',
        429613:	'彭市镇',
        429614:	'麻洋镇',
        429615:	'多祥镇',
        429616:	'干驿镇',
        429617:	'马湾镇',
        429618:	'卢市镇',
        429619:	'小板镇',
        429620:	'九真镇',
        429621:	'皂市镇',
        429622:	'胡市镇',
        429623:	'石河镇',
        429624:	'佛子山镇',
        429625:	'净潭乡',
        429626:	'蒋湖农场',
        429627:	'白茅湖农场',
        429628:	'沉湖管委会',
        429701:	'松柏镇',
        429702:	'阳日镇',
        429703:	'木鱼镇',
        429704:	'红坪镇',
        429705:	'新华镇',
        429706:	'九湖镇',
        429707:	'宋洛乡',
        429708:	'下谷坪土家族乡',
    }
}
